import Tutorials from './Tutorials'
import General from './General'
import Students from './Students'
import Assessments from './Assessments'
import Reports from './Reports'
import tutorialsHooks from './hooks'
import Header from './Header'

export { tutorialsHooks, Header, General, Students, Assessments, Reports }
export default Tutorials